/**
 * All known location data
 */
const _LOCATIONS = {
    "unknown": {
        "label": "Unknown",
        "continent": "Unknown",
        "uiIcon": "/assets/images/icons/spacer.png"
    },
    "dc_location-lhr": {
        "label": "London, England",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/uk.svg"
    },
    "dc_location-dfw": {
        "label": "Dallas TX, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "dc_location-lax": {
        "label": "Los Angeles CA, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east-1": {
        "label": "North Virginia, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east-2": {
        "label": "Ohio, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west-1": {
        "label": "North California, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west-2": {
        "label": "Oregon, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "ap-south-1": {
        "label": "Mumbai, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "ap-south-2": {
        "label": "Hyderabad, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "ap-northeast-1": {
        "label": "Tokyo, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "ap-northeast-2": {
        "label": "Seoul, South Korea",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/south-korea.svg"
    },
    "ap-northeast-3": {
        "label": "Osaka, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "ap-southeast-1": {
        "label": "Singapore, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/singapore.svg"
    },
    "ap-southeast-2": {
        "label": "Sydney, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "ca-central-1": {
        "label": "Canada (Central)",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/canada.svg"
    },
    "eu-central-1": {
        "label": "Frankfurt, Germany",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/germany.svg"
    },
    "eu-west-1": {
        "label": "Dublin, Ireland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/ireland.svg"
    },
    "eu-west-2": {
        "label": "London, UK",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/uk.svg"
    },
    "eu-west-3": {
        "label": "Paris, France",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/france.svg"
    },
    "eu-north-1": {
        "label": "Stockholm, Sweden",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/sweden.svg"
    },
    "sa-east-1": {
        "label": "São Paulo, Brazil",
        "continent": "South America",
        "uiIcon": "/assets/images/dc-locations/brazil.svg"
    },
    "ap-east-1": {
        "label": "Hong Kong, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/hong-kong.svg"
    },
    "af-south-1": {
        "label": "Cape Town, SA",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/south-africa.svg"
    },
    "ap-southeast-3": {
        "label": "Jakarta, Indonesia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/indonesia.svg"
    },
    "ap-southeast-4": {
        "label": "Melbourne, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "eu-south-1": {
        "label": "Milan, Italy",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/italy.svg"
    },
    "eu-south-2": {
        "label": "Zaragoza, Spain",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/spain.svg"
    },
    "eu-central-2": {
        "label": "Zurich, Switzerland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/switzerland.svg"
    },
    "me-south-1": {
        "label": "Bahrain",
        "continent": "Middle East",
        "uiIcon": "/assets/images/dc-locations/bahrain.svg"
    },
    "me-central-1": {
        "label": "UAE",
        "continent": "Middle East",
        "uiIcon": "/assets/images/dc-locations/uae.svg"
    },
    "asia-east1": {
        "label": "Changhua, Taiwan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/taiwan.svg"
    },
    "asia-east2": {
        "label": "Hong Kong, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/hong-kong.svg"
    },
    "asia-northeast1": {
        "label": "Tokyo, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "asia-northeast2": {
        "label": "Osaka, Japan",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/japan.svg"
    },
    "asia-northeast3": {
        "label": "Seoul, South Korea",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/south-korea.svg"
    },
    "asia-south1": {
        "label": "Mumbai, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "asia-south2": {
        "label": "Delhi, India",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/india.svg"
    },
    "asia-southeast1": {
        "label": "Singapore, Asia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/singapore.svg"
    },
    "asia-southeast2": {
        "label": "Jakarta, Indonesia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/indonesia.svg"
    },
    "australia-southeast1": {
        "label": "Sydney, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "australia-southeast2": {
        "label": "Melbourne, Australia",
        "continent": "Asia & Oceania",
        "uiIcon": "/assets/images/dc-locations/australia.svg"
    },
    "europe-central2": {
        "label": "Warsaw, Poland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/poland.svg"
    },
    "europe-north1": {
        "label": "Hamina, Finland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/finland.svg"
    },
    "europe-southwest1": {
        "label": "Madrid, Spain",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/spain.svg"
    },
    "europe-west1": {
        "label": "St. Ghislain, Belgium",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/belgium.svg"
    },
    "europe-west12": {
        "label": "Turin, Italy",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/italy.svg"
    },
    "europe-west2": {
        "label": "London, England",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/uk.svg"
    },
    "europe-west3": {
        "label": "Frankfurt, Germany",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/germany.svg"
    },
    "europe-west4": {
        "label": "Eemshaven, Netherlands",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/netherlands.svg"
    },
    "europe-west6": {
        "label": "Zurich, Switzerland",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/switzerland.svg"
    },
    "europe-west8": {
        "label": "Milan, Italy",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/italy.svg"
    },
    "europe-west9": {
        "label": "Paris, France",
        "continent": "Europe",
        "uiIcon": "/assets/images/dc-locations/france.svg"
    },
    "me-west1": {
        "label": "Tel Aviv, Israel",
        "continent": "Middle East",
        "uiIcon": "/assets/images/dc-locations/israel.svg"
    },
    "northamerica-northeast1": {
        "label": "Montréal, Québec",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/canada.svg"
    },
    "northamerica-northeast2": {
        "label": "Toronto, Ontario",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/canada.svg"
    },
    "southamerica-east1": {
        "label": "São Paulo, Brazil",
        "continent": "South America",
        "uiIcon": "/assets/images/dc-locations/brazil.svg"
    },
    "southamerica-west1": {
        "label": "Santiago, Chile",
        "continent": "South America",
        "uiIcon": "/assets/images/dc-locations/chile.svg"
    },
    "us-central1": {
        "label": "Iowa, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east1": {
        "label": "South Carolina, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east4": {
        "label": "Virginia, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-east5": {
        "label": "Ohio, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-south1": {
        "label": "Texas, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west1": {
        "label": "Oregon, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west2": {
        "label": "California, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west3": {
        "label": "Utah, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    },
    "us-west4": {
        "label": "Nevada, USA",
        "continent": "North America",
        "uiIcon": "/assets/images/dc-locations/usa.svg"
    }
}

/**
 * Utility class to handle server dcLocations
 */
class ServerLocationUtils {
    /**
     * Returns the icon for a given location code
     *
     * @param {string} locationCode - the location code for which the icon is required
     * @returns {string} the icon for the location code
     */
    static uiIcon(locationCode) {
        let location = locationCode

        if (typeof _LOCATIONS[location] == 'undefined') {
            location = 'unknown'
        }

        return _LOCATIONS[location].uiIcon
    }

    /**
     * Returns the user-friendly label for a given location code
     *
     * @param {string} locationCode - the location code for which the label is required
     * @returns {string} the user-friendly label for the location code
     */
    static uiFriendlyLabel(locationCode) {
        let location = locationCode

        if (typeof _LOCATIONS[location] == 'undefined') {
            location = 'unknown'
        }

        return _LOCATIONS[location].label
    }
    /**
    * Returns a trimmed version of the user-friendly label for a given location code
    *
    * @param {string} locationCode - the location code for which the label is required
    * @returns {string} the user-friendly label for the location code
    */
    static shortUiFriendlyLabel(locationCode) {
        const str = this.uiFriendlyLabel(locationCode)
        const commaIdx = str.indexOf(',');
        const parenIdx = str.indexOf('(');
        const words = str.trim().split(/\s+/);
        const secondWordIdx = words.length >= 2
            ? str.indexOf(words[1], str.indexOf(words[0]) + words[0].length) + words[1].length
            : str.length;

        const cutPoints = [commaIdx, parenIdx, secondWordIdx]
            .filter(i => i !== -1); // Remove not-found (-1)

        const trimIdx = Math.min(...cutPoints);

        return str.substring(0, trimIdx).trim();

    }
    /**
     * Returns the continent string for a given location code
     *
     * @param {string} locationCode - the location code for which the continent string is required
     * @returns {string} the continent string for the location code
     */
    static uiFriendlyContinentLabel(locationCode) {
        let location = locationCode

        if (typeof _LOCATIONS[location] == 'undefined') {
            location = 'unknown'
        }

        return _LOCATIONS[location].continent
    }
}
